__turbopack_context__.v({
  "audioPlayButton": "styles-module__le4isW__audioPlayButton",
  "playButtonBase": "styles-module__le4isW__playButtonBase",
  "videoBackground": "styles-module__le4isW__videoBackground",
  "videoContainer": "styles-module__le4isW__videoContainer",
  "videoPlayButton": "styles-module__le4isW__videoPlayButton",
  "videoSpinner": "styles-module__le4isW__videoSpinner",
});
